import TawkMessengerVue from "@tawk.to/tawk-messenger-vue-3"
import { App } from "vue"
import { useWindowSize } from "./composables/useWindowSize"
import { type AppEvents, EventBus } from "@/services/eventBus"

export const bus = new EventBus<AppEvents>()

export const initTawk = (app: App<Element>) => {
  let initialized = false
  const tawkElementId = `tawk_${process.env.VUE_APP_TAWK_ID}`

  const { isMobile, isTablet } = useWindowSize()

  const initializeTawk = () => {
    if (!initialized) {
      app.use(TawkMessengerVue, {
        propertyId: process.env.VUE_APP_TAWK_ID,
        widgetId: process.env.VUE_APP_TAWK_WIDGET_ID,
        embedId: tawkElementId,
      })

      initialized = true
      console.log(`Tawk Messenger has been mounted to ${tawkElementId}`)
    }
  }

  const applyStyles = () => {
    const iframe = document.querySelector(
      'iframe[title="chat widget"]'
    ) as HTMLIFrameElement

    if (iframe) {
      const mainDocument =
        iframe.contentDocument || iframe.contentWindow?.document

      if (!mainDocument) return

      const widgetContainer = document.getElementById(
        "tawk_68b6e6e233aba2192204c36f"
      ) as HTMLElement

      if (widgetContainer) {
        widgetContainer.style.setProperty("flex-grow", "1", "important")
      }

      const widgetPanel = document.querySelector(
        ".widget-visible"
      ) as HTMLElement
      if (widgetPanel) {
        widgetPanel.style.setProperty("min-height", "100%", "important")
        widgetPanel.style.setProperty("min-width", "100%", "important")
      }

      if (isMobile.value || isTablet.value) {
        const tawkContainer = mainDocument.querySelector(
          ".tawk-max-container"
        ) as HTMLElement
        if (tawkContainer) {
          tawkContainer.style.setProperty(
            "height",
            // "calc(100% - 83px -16px)",
            "calc(100% - 100px)",
            "important"
          )
        }
      }

      // const tawkFooter = mainDocument.querySelector(
      //   ".tawk-footer"
      // ) as HTMLElement | null

      // if (tawkFooter) {
      //   const containers = tawkFooter.querySelectorAll(":scope > div")

      //   containers.forEach((div) => {
      //     console.log(div instanceof HTMLElement)
      //     console.log(div)

      //     if (
      //       div instanceof HTMLElement &&
      //       div.id !== "tawk-chatinput-container"
      //     ) {
      //       div.style.setProperty("display", "none", "important")
      //     }
      //   })
      // }

      const chatPanel = mainDocument.querySelector(
        ".tawk-chat-panel"
      ) as HTMLElement

      if (chatPanel) {
        chatPanel.style.setProperty(
          "background-color",
          "rgb(33, 33, 33)",
          "important"
        )
      }

      const chatOverlay = mainDocument.querySelector(
        ".tawk-overlay"
      ) as HTMLElement

      if (chatOverlay) {
        chatOverlay.style.setProperty("border", "none", "important")
      }

      const messageItems = mainDocument.querySelectorAll(
        ".tawk-button-small"
      ) as NodeListOf<HTMLElement>
      messageItems.forEach((item) => {
        item.style.setProperty("background-color", "#2d2f33", "important")
        item.style.setProperty("color", "#ffffff", "important")
      })

      console.log("Tawk widget styles applied.")
    }
  }

  setTimeout(() => {
    initializeTawk()
  }, 1500)

  const intervalId = setInterval(() => {
    const iframe = document.querySelector('iframe[title="chat widget"]')
    if (iframe) {
      if (window.location.pathname.startsWith("/admin")) {
        window.Tawk_API.shutdown()
      } else {
        applyStyles()
      }
      clearInterval(intervalId)
    }
  }, 500)
}
